import ImageSlider from "./ImageSlider";
import { useEffect, useState } from "react";
import { get, ref } from "firebase/database";
import { realTimeDB } from "./firebase";

const ShowSlider = () => {
  const [slides, setSlides]=useState([]);

  useEffect(()=>{
    async function fetchPictures() {
      const homePicsSnapshot = await get(ref(realTimeDB,"home pictures"));
      const homePicsChildData = homePicsSnapshot.val();
      const homePicsArray = Object.keys(homePicsChildData).map((key)=>({
        id: key,
        ...homePicsChildData[key]
      }));
      setSlides(homePicsArray);
    }
    fetchPictures();
  },[]);

 

    return ( 
      <div className="show-slider">
       {slides && <ImageSlider slides={slides}/>} 
      </div>
     );
}
export default ShowSlider;